export default __webpack_public_path__ + "images/530674f96b610b969707aa579c73618b.png";